import { settings } from "../kernel/Settings";
export class WebConfigAPI {
    /**
     * @see https://brain-ai.atlassian.net/browse/STUD-1138?focusedCommentId=47009
     */
    async fetchWebConfig() {
        const url = settings.templatesProjectUrl;
        return fetch(url).then(res => res.json());
    }
}
